import { createContext, useContext } from 'react';
import { toastFormError } from '../../formUtils';

/**
 * readOnly — редактор только для чтения. Решает бэк: form.can_edit уже
 * учитывает роль, статус формы и закончившийся год, фронт правила заново
 * не выводит. reportError(err, fallback) — единая точка показа ошибок
 * записи (403/409 и т.п.) для всех вложенных компонентов редактора.
 */
export const FormEditContext = createContext({
  readOnly: false,
  reportError: toastFormError,
});

export const useFormEdit = () => useContext(FormEditContext);
